module.exports = __webpack_public_path__ + "static/media/ca_insight_logo.fd754c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partials/assets/ca_insight_logo.png
// module id = 488
// module chunks = 0